const components = {
  MuiCssBaseline: {
    styleOverrides: {
      'textarea.jst-textarea': {
        width: '100%',
        minHeight: '60px',
        padding: '12px',
        borderRadius: '6px',
        boxSizing: 'border-box',
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
        border: '1px solid var(--color-dark-greyish-blue)',
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        fontSize: '14px',
        lineHeight: 1.5,
        resize: 'vertical',
        '&::placeholder': {
          color: 'var(--color-very-dark-greyish-blue)',
          opacity: 1,
        },
        '&:hover': {
          borderColor: 'var(--color-dark-greyish-blue)',
        },
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '-2px',
        },
        '&:disabled': {
          backgroundColor: 'var(--color-light-greyish-blue)',
          cursor: 'not-allowed',
        },
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiCircularProgress: {
    styleOverrides: {
      root: {
        color: 'var(--color-scifree-teal)',
      },
    },
  },
  MuiSwitch: {
    styleOverrides: {
      root: {
        '& .MuiSwitch-switchBase': {
          color: 'var(--color-greyish-blue)',
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&:hover .MuiSwitch-thumb': {
            boxShadow: 'none',
          },
          '&.Mui-disabled:hover .MuiSwitch-thumb': {
            boxShadow: 'none',
          },
          '& .MuiSwitch-thumb': {
            backgroundColor: 'currentColor',
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            outline: '2px solid var(--color-scifree-teal)',
            outlineOffset: 2,
          },
          '&.Mui-checked': {
            color: 'var(--color-scifree-teal)',
            '& + .MuiSwitch-track': {
              backgroundColor: 'var(--color-mid-greyish-blue)',
              opacity: 1,
            },
          },
        },
        '& .MuiSwitch-track': {
          backgroundColor: 'var(--color-mid-greyish-blue)',
          opacity: 1,
        },
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:hover .MuiSvgIcon-root': {
          boxShadow: '0 0 0 6px var(--color-light-greyish-blue)',
          borderRadius: '50%',
        },
        '&.Mui-disabled:hover .MuiSvgIcon-root': {
          boxShadow: 'none',
        },
        '&.Mui-checked, &.MuiCheckbox-indeterminate': {
          color: 'var(--color-scifree-teal)',
        },
        '&:focus-visible, &.Mui-focusVisible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '-3px',
          borderRadius: '50%',
        },
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        display: 'inline-flex',
        width: 'fit-content',
        maxWidth: '100%',
        backgroundColor: 'var(--color-white)',
        border: '1px solid var(--color-scifree-teal)',
        borderRadius: '6px',
        overflow: 'hidden',
        minHeight: '40px',
      },
      scroller: {
        minHeight: '40px',
        maxWidth: '100%',
        overflow: 'visible',
        '&.MuiTabs-scrollableX': {
          overflowX: 'visible',
        },
      },
      flexContainer: {
        minHeight: '40px',
        flexWrap: 'wrap',
        width: 'fit-content',
        maxWidth: '100%',
      },
      indicator: {
        display: 'none',
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-scifree-teal)',
        textTransform: 'none',
        minHeight: '40px',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
          color: 'var(--color-scifree-teal)',
        },
        '&.Mui-selected': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected:focus-visible, &.Mui-selected.Mui-focusVisible': {
          outline: '2px solid var(--color-white)',
          outlineOffset: '-4px',
          borderRadius: '6px',
        },
        '&:not(.Mui-selected):focus-visible, &:not(.Mui-selected).Mui-focusVisible':
          {
            outline: '2px solid var(--color-scifree-teal)',
            outlineOffset: '2px',
          },
      },
    },
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: {
        display: 'inline-flex',
        width: 'fit-content',
        maxWidth: '100%',
        backgroundColor: 'var(--color-white)',
        border: '1px solid var(--color-scifree-teal)',
        borderRadius: '6px',
        overflow: 'hidden',
        flexWrap: 'wrap',
        gap: 0,
      },
      grouped: {
        border: 0,
        margin: 0,
        borderRadius: 0,
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-scifree-teal)',
        textTransform: 'none',
        border: 0,
        borderRadius: 0,
        minHeight: '40px',
        padding: '6px 12px',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
          color: 'var(--color-scifree-teal)',
        },
        '&.Mui-selected': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected:focus-visible, &.Mui-selected.Mui-focusVisible': {
          outline: '2px solid var(--color-white)',
          outlineOffset: '-4px',
          borderRadius: '6px',
        },
        '&:not(.Mui-selected):focus-visible, &:not(.Mui-selected).Mui-focusVisible':
          {
            outline: '2px solid var(--color-scifree-teal)',
            outlineOffset: '-3px',
            borderRadius: '6px',
          },
      },
      sizeSmall: {
        minHeight: '32px',
        padding: '4px 10px',
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&:focus-visible, &.Mui-focusVisible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '-1px',
          borderRadius: '50%',
        },
      },
    },
  },
  MuiLink: {
    defaultProps: {
      underline: 'always',
    },
    styleOverrides: {
      root: {
        color: 'var(--color-deep-ocean-blue)',
        textDecorationColor: 'var(--color-deep-ocean-blue)',
        '&:visited': {
          color: 'var(--color-deep-ocean-blue)',
          textDecorationColor: 'var(--color-deep-ocean-blue)',
        },
        '&:hover': {
          textDecorationColor: 'var(--color-scifree-teal)',
          color: 'var(--color-scifree-teal)',
        },
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '4px',
          borderRadius: '2px',
        },
      },
    },
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: 'h6',
      },
    },
    styleOverrides: {
      action: {
        marginTop: '-4px',
        marginRight: '-4px',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '6px',
        backgroundImage: 'none',
        border: '1px solid var(--color-greyish-blue)',
        color: 'var(--color-deep-ocean-blue)',
        padding: '24px',
        '&[role="button"]': {
          cursor: 'pointer',
          '&:focus-visible': {
            outline: '2px solid var(--color-scifree-teal)',
            outlineOffset: '-2px',
          },
        },
      },
    },
    variants: [
      {
        props: { variant: 'default' },
        style: {
          backgroundColor: 'var(--color-white)',
        },
      },
      {
        props: { variant: 'primary' },
        style: {
          backgroundColor: 'var(--color-white)',
          '&:hover': {
            backgroundColor: 'var(--color-light-greyish-blue)',
            cursor: 'pointer',
          },
        },
      },
      {
        props: { variant: 'secondary' },
        style: {
          backgroundColor: 'var(--color-greyish-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-light-greyish-blue)',
          },
        },
      },
    ],
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
      },
    },
  },
  MuiBox: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        color: 'var(--color-deep-ocean-blue)',
        fontWeight: 400,
        '&.Mui-selected': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'var(--color-deep-ocean-blue)',
        },
        '&.Mui-selected.Mui-focusVisible': {
          backgroundColor: 'var(--color-scifree-teal)',
        },
      },
    },
  },
  MuiDayCalendar: {
    styleOverrides: {
      weekDayLabel: {
        color: 'var(--color-deep-ocean-blue)',
      },
    },
  },
  MuiPickersYear: {
    styleOverrides: {
      root: {
        height: '64px',
      },
      yearButton: {
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'var(--color-deep-ocean-blue)',
        },
        '&.Mui-selected.Mui-focusVisible': {
          backgroundColor: 'var(--color-scifree-teal)',
        },
      },
    },
  },
  MuiPickersCalendar: {
    styleOverrides: {
      transitionContainer: {
        marginTop: '6px',
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      iconButton: {
        backgroundColor: 'transparent',
        borderRadius: '50%',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '& > *': {
          backgroundColor: 'transparent',
        },
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '2px',
          borderRadius: '2px',
        },
      },
      label: {
        color: 'var(--color-deep-ocean-blue)',
      },
      switchViewIcon: {
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '2px',
          borderRadius: '2px',
        },
      },
      switchHeader: {
        marginTop: '2px',
        marginBottom: '4px',
      },
    },
  },
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      button: {
        padding: '4px',
        margin: '0',
        borderRadius: '50%',
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
      },
    },
  },
  MuiPickersPopper: {
    styleOverrides: {
      paper: {
        border: '1px solid var(--color-dark-greyish-blue)',
        borderRadius: '6px',
      },
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiIconButton-root': {
          color: 'var(--color-deep-ocean-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-light-greyish-blue)',
          },
          '&:focus-visible, &.Mui-focusVisible': {
            outline: '2px solid var(--color-scifree-teal)',
            outlineOffset: '-3px',
            borderRadius: '2px',
          },
        },
        '& .MuiSvgIcon-root': {
          color: 'inherit',
        },
      },
    },
  },
  MuiPickersClock: {
    styleOverrides: {
      container: {
        margin: `32px 0 4px`,
      },
    },
  },
  MuiPickersClockNumber: {
    styleOverrides: {
      clockNumber: {
        left: `calc(50% - 16px)`,
        width: '32px',
        height: '32px',
      },
    },
  },
  MuiPickerDTHeader: {
    styleOverrides: {
      dateHeader: {
        '& h4': {
          fontSize: '2.125rem',
          fontWeight: 400,
        },
      },
      timeHeader: {
        '& h3': {
          fontSize: '3rem',
          fontWeight: 400,
        },
      },
    },
  },
  MuiPickersTimePicker: {
    styleOverrides: {
      hourMinuteLabel: {
        '& h2': {
          fontSize: '3.75rem',
          fontWeight: 300,
        },
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      toolbar: {
        '& h4': {
          fontSize: '2.125rem',
          fontWeight: 400,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontWeight: 600,
        borderRadius: '6px',
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '2px',
        },
        '&:disabled': {
          pointerEvents: 'none',
          opacity: 0.5,
        },
      },
    },
    variants: [
      {
        props: { variant: 'default' },
        style: {
          backgroundColor: 'var(--color-white)',
          color: 'var(--color-scifree-teal)',
          border: '1px solid var(--color-scifree-teal)',
          '&:hover': {
            backgroundColor: 'var(--color-light-greyish-blue)',
            color: 'var(--color-scifree-teal)',
          },
          '&:focus, &:focus-visible': {
            backgroundColor: 'var(--color-white)',
            color: 'var(--color-scifree-teal)',
          },
          '&:disabled': {
            backgroundColor: 'var(--color-white)',
            color: 'var(--color-scifree-teal)',
          },
        },
      },
      {
        props: { variant: 'primary' },
        style: {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-deep-ocean-blue)',
            color: 'var(--color-light-greyish-blue)',
          },
          '&:focus, &:focus-visible': {
            backgroundColor: 'var(--color-scifree-teal)',
            color: 'var(--color-light-greyish-blue)',
          },
          '&:disabled': {
            backgroundColor: 'var(--color-scifree-teal)',
            color: 'var(--color-light-greyish-blue)',
          },
        },
      },
      {
        props: { variant: 'secondary' },
        style: {
          backgroundColor: 'var(--color-greyish-blue)',
          color: 'var(--color-deep-ocean-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-greyish-blue)',
            color: 'var(--color-deep-ocean-blue)',
          },
          '&:focus, &:focus-visible': {
            backgroundColor: 'var(--color-greyish-blue)',
            color: 'var(--color-deep-ocean-blue)',
          },
          '&:has([role="button"]:focus-visible)': {
            backgroundColor: 'var(--color-greyish-blue)',
          },
          '&:disabled': {
            backgroundColor: 'var(--color-greyish-blue)',
            color: 'var(--color-deep-ocean-blue)',
          },
        },
      },
      {
        props: { variant: 'success' },
        style: {
          backgroundColor: 'var(--color-light-greyish-lime-green)',
          color: 'var(--color-deep-ocean-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-light-greyish-lime-green)',
            color: 'var(--color-deep-ocean-blue)',
            filter: 'saturate(2) brightness(0.9)',
          },
          '&:focus, &:focus-visible': {
            backgroundColor: 'var(--color-light-greyish-lime-green)',
            color: 'var(--color-deep-ocean-blue)',
          },
          '&:disabled': {
            backgroundColor: 'var(--color-light-greyish-lime-green)',
            color: 'var(--color-deep-ocean-blue)',
          },
        },
      },
      {
        props: { variant: 'warning' },
        style: {
          backgroundColor: 'var(--color-light-grey-red)',
          color: 'var(--color-deep-ocean-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-light-grey-red)',
            color: 'var(--color-deep-ocean-blue)',
            filter: 'saturate(2) brightness(0.9)',
          },
          '&:focus, &:focus-visible': {
            backgroundColor: 'var(--color-light-grey-red)',
            color: 'var(--color-deep-ocean-blue)',
          },
          '&:disabled': {
            backgroundColor: 'var(--color-light-grey-red)',
            color: 'var(--color-deep-ocean-blue)',
          },
        },
      },
    ],
  },
  MuiBadge: {
    styleOverrides: {
      badge: {
        fontWeight: 700,
        fontSize: 12,
        lineHeight: 1,
        minWidth: 18,
        height: 18,
        padding: '0 6px',
        borderRadius: 9999,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0.375rem',
        fontWeight: 500,
        transitionProperty: 'background-color, border-color, color',
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
        transitionDuration: '150ms',
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '2px',
        },
        '&.Mui-disabled, &:disabled': {
          pointerEvents: 'none',
          opacity: 0.5,
        },
      },
      sizeSmall: {
        fontSize: '0.8125rem',
        padding: '4px 10px',
      },
      sizeMedium: {
        fontSize: '0.875rem',
        padding: '6px 16px',
      },
      sizeLarge: {
        fontSize: '0.875rem',
        padding: '8px 22px',
      },
    },
    variants: [
      {
        props: { variant: 'default' },
        style: {
          backgroundColor: 'var(--color-white)',
          color: 'var(--color-scifree-teal)',
          border: '1px solid var(--color-scifree-teal)',
          '&:hover': {
            backgroundColor: 'var(--color-light-greyish-blue)',
            color: 'var(--color-scifree-teal)',
          },
          '&.Mui-disabled, &:disabled': {
            backgroundColor: 'var(--color-white)',
            color: 'var(--color-scifree-teal)',
          },
        },
      },
      {
        props: { variant: 'primary' },
        style: {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-deep-ocean-blue)',
            color: 'var(--color-light-greyish-blue)',
          },
          '&.Mui-disabled, &:disabled': {
            backgroundColor: 'var(--color-scifree-teal)',
            color: 'var(--color-light-greyish-blue)',
          },
        },
      },
      {
        props: { variant: 'secondary' },
        style: {
          color: 'var(--color-deep-ocean-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-light-greyish-blue)',
            color: 'var(--color-deep-ocean-blue)',
          },
          '&.Mui-disabled, &:disabled': {
            backgroundColor: 'var(--color-white)',
            color: 'var(--color-deep-ocean-blue)',
          },
        },
      },
      {
        props: { variant: 'warning' },
        style: {
          backgroundColor: 'var(--color-grey-red)',
          color: 'var(--color-light-greyish-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-dark-grey-red)',
            color: 'var(--color-light-greyish-blue)',
          },
          '&.Mui-disabled, &:disabled': {
            backgroundColor: 'var(--color-grey-red)',
            color: 'var(--color-light-greyish-blue)',
          },
        },
      },
      {
        props: { variant: 'warningSecondary' },
        style: {
          color: 'var(--color-grey-red)',
          '&:hover': {
            backgroundColor: 'var(--color-light-grey-red)',
            color: 'var(--color-grey-red)',
          },
          '&.Mui-disabled, &:disabled': {
            backgroundColor: 'var(--color-white)',
            color: 'var(--color-grey-red)',
          },
        },
      },
      {
        props: { variant: 'link' },
        style: {
          color: 'var(--color-deep-ocean-blue)',
          '&:hover': {
            textDecoration: 'underline',
            backgroundColor: 'transparent',
          },
          '&:disabled': {
            color: 'var(--color-deep-ocean-blue)',
          },
        },
      },
      {
        props: { variant: 'warningLink' },
        style: {
          color: 'var(--color-grey-red)',
          '&:hover': {
            textDecoration: 'underline',
            backgroundColor: 'transparent',
          },
          '&:disabled': {
            color: 'var(--color-grey-red)',
          },
        },
      },
      {
        props: { variant: 'navigation' },
        style: (() => {
          const isStaging = import.meta.env.REACT_APP_BUILD === 'staging';
          return {
            backgroundColor: isStaging
              ? 'var(--color-staging-navigation)'
              : 'var(--color-deep-ocean-blue)',
            color: 'var(--color-light-greyish-blue)',
            '&:hover': {
              backgroundColor: 'var(--color-scifree-teal)',
              color: 'var(--color-light-greyish-blue)',
            },
            '&:disabled': {
              backgroundColor: isStaging
                ? 'var(--color-staging-navigation)'
                : 'var(--color-deep-ocean-blue)',
              color: 'var(--color-light-greyish-blue)',
              opacity: 0.5,
            },
          };
        })(),
      },
    ],
  },
  MuiAutocomplete: {
    defaultProps: {
      size: 'small',
    },
    styleOverrides: {
      popper: {
        zIndex: 1500,
      },
      paper: {
        borderRadius: '6px',
        border: '1px solid var(--color-dark-greyish-blue)',
        marginTop: '4px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
      },
      listbox: {
        padding: 0,
        '& .MuiAutocomplete-option:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '& .MuiAutocomplete-option.Mui-focused': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '& .MuiAutocomplete-option[aria-selected="true"]': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '& .MuiAutocomplete-option[aria-selected="true"]:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
      },
      option: {
        padding: '10px 12px',
        minHeight: 'unset',
        fontSize: '14px',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&[aria-selected="true"]': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&[aria-selected="true"]:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-focused': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-focused[aria-selected="true"]': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-focusVisible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '-2px',
        },
      },
      clearIndicator: {
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          color: 'var(--color-scifree-teal)',
        },
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '2px',
          borderRadius: '2px',
        },
      },
      popupIndicator: {
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&:focus-visible': {
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '2px',
          borderRadius: '2px',
        },
      },
      noOptions: {
        padding: '12px',
        fontSize: '14px',
        color: 'var(--color-deep-ocean-blue)',
      },
      loading: {
        padding: '12px',
        fontSize: '14px',
        color: 'var(--color-deep-ocean-blue)',
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: '6px',
        border: '1px solid var(--color-dark-greyish-blue)',
        marginTop: '4px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
      },
      list: {
        padding: 0,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        padding: '10px 12px',
        minHeight: 'unset',
        fontSize: '14px',
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '&.Mui-focusVisible': {
          backgroundColor: 'var(--color-light-greyish-blue)',
          outline: '2px solid var(--color-scifree-teal)',
          outlineOffset: '-2px',
        },
        '&.Mui-selected.Mui-focusVisible': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
      },
    },
  },
  MuiTooltip: {
    defaultProps: {
      arrow: true,
    },
    styleOverrides: {
      tooltip: {
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
        borderRadius: '6px',
        padding: '8px 10px',
        fontSize: '12px',
        lineHeight: 1.4,
        boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
      },
      arrow: {
        color: 'var(--color-white)',
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      size: 'small',
      MenuProps: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        PaperProps: {
          sx: {
            mt: '4px',
            maxHeight: '40vh',
          },
        },
        onKeyDown: (e: React.KeyboardEvent) => {
          if (e.key === ' ') {
            e.preventDefault();
            const active = e.target as HTMLElement;
            if (active?.click) active.click();
          }
        },
      },
    },
    styleOverrides: {
      root: {
        // Avoid contrast error (accessibility). MUI hides the native select input with transparent text.
        '& .MuiSelect-nativeInput': {
          clip: 'rect(0, 0, 0, 0)',
          opacity: 1,
          color: 'var(--color-deep-ocean-blue)',
          backgroundColor: 'var(--color-white)',
        },
      },
      select: {
        '&.MuiInputBase-inputSizeSmall': {
          paddingTop: '8px',
          paddingBottom: '8px',
        },
      },
      icon: {
        color: 'var(--color-deep-ocean-blue)',
      },
      iconOpen: {
        color: 'var(--color-deep-ocean-blue)',
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      size: 'small',
    },
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: 'var(--color-deep-ocean-blue)',
      },
    },
    variants: [
      {
        props: { variant: 'h1' },
        style: { fontSize: '32px', fontWeight: 600, lineHeight: 1.25 },
      },
      {
        props: { variant: 'h2' },
        style: { fontSize: '28px', fontWeight: 600, lineHeight: 1.25 },
      },
      {
        props: { variant: 'h3' },
        style: { fontSize: '24px', fontWeight: 600, lineHeight: 1.25 },
      },
      {
        props: { variant: 'h4' },
        style: { fontSize: '18px', fontWeight: 600, lineHeight: 1.25 },
      },
      {
        props: { variant: 'h5' },
        style: {
          fontSize: '17px',
          fontWeight: 500,
          lineHeight: 1.25,
          color: 'var(--color-scifree-teal)',
        },
      },
      {
        props: { variant: 'h6' },
        style: { fontSize: '16px', fontWeight: 500, lineHeight: 1.25 },
      },
      {
        props: { variant: 'subtitle1' },
        style: { fontSize: '13px', fontWeight: 500, lineHeight: 1.5 },
      },
      {
        props: { variant: 'subtitle2' },
        style: {
          fontSize: '13px',
          fontWeight: 400,
          lineHeight: 1.5,
          color: 'var(--color-dark-grey-red)',
        },
      },
      {
        props: { variant: 'body1' },
        style: { fontSize: '13px', fontWeight: 400, lineHeight: 1.5 },
      },
      {
        props: { variant: 'body2' },
        style: {
          fontSize: '13px',
          fontWeight: 400,
          lineHeight: 1.5,
          color: 'var(--color-very-dark-greyish-blue)',
        },
      },
      {
        props: { variant: 'caption' },
        style: { fontSize: '12px', fontWeight: 500, lineHeight: 1.25 },
      },
      {
        props: { variant: 'overline' },
        style: {
          fontSize: '12px',
          fontWeight: 500,
          letterSpacing: '0.08333em',
          textTransform: 'uppercase',
          lineHeight: 1.25,
        },
      },
    ],
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
        minHeight: '40px',
        '& .MuiSelect-icon': {
          color: 'var(--color-deep-ocean-blue)',
          borderRadius: '50%',
          transition: 'background-color 150ms ease, color 150ms ease',
        },
        '&:hover .MuiSelect-icon': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--color-dark-greyish-blue)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--color-dark-greyish-blue)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--color-scifree-teal)',
          borderWidth: '2px',
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--color-grey-red)',
        },
        '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--color-grey-red)',
        },
        '&.Mui-disabled': {
          backgroundColor: 'var(--color-light-greyish-blue)',
        },
      },
      input: {
        color: 'var(--color-deep-ocean-blue)',
        '&::placeholder': {
          color: 'var(--color-very-dark-greyish-blue)',
          opacity: 1,
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: 'var(--color-very-dark-greyish-blue)',
        '&.Mui-focused': {
          color: 'var(--color-scifree-teal)',
        },
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        color: 'var(--color-very-dark-greyish-blue)',
        '&.Mui-error': {
          color: 'var(--color-grey-red)',
        },
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: '6px',
        alignItems: 'center',
        '& .MuiAlert-message': {
          padding: '2px 0',
        },
        '& .MuiAlert-action': {
          paddingTop: 0,
          alignItems: 'center',
        },
      },

      // STANDARD
      standardSuccess: {
        backgroundColor: 'var(--color-light-greyish-lime-green)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-scifree-teal)' },
      },
      standardInfo: {
        backgroundColor: 'var(--color-light-greyish-blue)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-scifree-teal)' },
      },
      standardWarning: {
        backgroundColor: 'var(--color-very-pale-orange)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-deep-ocean-blue)' },
      },
      standardError: {
        backgroundColor: 'var(--color-light-grey-red)',
        color: 'var(--color-dark-grey-red)',
        '& .MuiAlert-icon': { color: 'var(--color-grey-red)' },
      },

      // OUTLINED
      outlinedSuccess: {
        backgroundColor: 'var(--color-white)',
        border: '1px solid var(--color-light-greyish-lime-green)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-scifree-teal)' },
      },
      outlinedInfo: {
        backgroundColor: 'var(--color-white)',
        border: '1px solid var(--color-light-greyish-blue)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-scifree-teal)' },
      },
      outlinedWarning: {
        backgroundColor: 'var(--color-white)',
        border: '1px solid var(--color-very-pale-orange)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-deep-ocean-blue)' },
      },
      outlinedError: {
        backgroundColor: 'var(--color-white)',
        border: '1px solid var(--color-dark-grey-red)',
        color: 'var(--color-dark-grey-red)',
        '& .MuiAlert-icon': { color: 'var(--color-dark-grey-red)' },
      },

      // FILLED
      filledSuccess: {
        backgroundColor: 'var(--color-light-greyish-lime-green)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-deep-ocean-blue)' },
        '& .MuiAlert-action': { color: 'var(--color-deep-ocean-blue)' },
      },
      filledInfo: {
        backgroundColor: 'var(--color-light-greyish-blue)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-deep-ocean-blue)' },
        '& .MuiAlert-action': { color: 'var(--color-deep-ocean-blue)' },
      },
      filledWarning: {
        backgroundColor: 'var(--color-very-pale-orange)',
        color: 'var(--color-deep-ocean-blue)',
        '& .MuiAlert-icon': { color: 'var(--color-deep-ocean-blue)' },
        '& .MuiAlert-action': { color: 'var(--color-deep-ocean-blue)' },
      },
      filledError: {
        backgroundColor: 'var(--color-dark-grey-red)',
        color: 'var(--color-white)',
        '& .MuiAlert-icon': { color: 'var(--color-white)' },
        '& .MuiAlert-action': { color: 'var(--color-white)' },
      },
    },
  },
  MuiAlertTitle: {
    styleOverrides: {
      root: {
        fontWeight: 600,
        marginBottom: '2px',
        color: 'inherit',
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        marginTop: '24px',
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--color-scifree-teal)',
        '& tr': {
          backgroundColor: 'var(--color-scifree-teal)',
          '&:hover': {
            backgroundColor: 'var(--color-scifree-teal)',
          },
        },
        '& th': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
          '&:hover': {
            backgroundColor: 'var(--color-scifree-teal)',
            color: 'var(--color-light-greyish-blue)',
          },
        },
      },
    },
  },
  MuiTableBody: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--color-white)',
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-deep-ocean-blue)',
        '&:hover': {
          backgroundColor: 'var(--color-light-greyish-blue)',
          color: 'var(--color-deep-ocean-blue)',
        },
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontSize: '14px',
        color: 'var(--color-deep-ocean-blue)',
      },
      head: {
        backgroundColor: 'var(--color-scifree-teal)',
        color: 'var(--color-light-greyish-blue)',
        fontSize: '14px',
        fontWeight: 'bold',
        '&:hover': {
          backgroundColor: 'var(--color-scifree-teal)',
          color: 'var(--color-light-greyish-blue)',
        },
      },
    },
  },
};

export default components;
